import React from 'react';
import { Box, Typography, styled } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

interface ReadOnlyStatusIndicatorProps {
  label?: string;
  value: boolean;
  activeText?: string;
  inactiveText?: string;
}

const StatusContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const StatusText = styled(Typography)(() => ({
  fontWeight: 500,
}));

export const ReadOnlyStatusIndicator: React.FC<ReadOnlyStatusIndicatorProps> = ({
  label,
  value,
  activeText = 'Active',
  inactiveText = 'Inactive',
}) => {
  return (
    <StatusContainer>
      {label && (
        <Typography variant="body1" color="text.secondary" sx={{ mr: 1 }}>
          {label}:
        </Typography>
      )}
      {value ? (
        <>
          <CheckCircleIcon color="success" />
          <StatusText color="success.main">{activeText}</StatusText>
        </>
      ) : (
        <>
          <CancelIcon color="error" />
          <StatusText color="error.main">{inactiveText}</StatusText>
        </>
      )}
    </StatusContainer>
  );
};
